import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addOaidFile from "./components/addOaidFile";
export default {
  name: "oaidFileManagement",
  mixins: [loadMoreList],
  components: {
    addOaidFile: addOaidFile
  },
  data: function data() {
    return {
      pagingReqFn: "oaidConfigManageList",
      delIds: []
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'oaidConfigManageDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    }
  }
};